// 法人編集履歴の定義リストを生成する
import React, { memo } from 'react';
interface Props {
  label: string;
  value?: string | number | null;
  status?: string;
}

const CorporateCreateDefinitionList: React.FC<Props> = ({ label, value, status }) => {
  return (
    <dl className="field_section">
      <dt className="field_label">{label}</dt>
      <dd className="field_data">{value ?? status}</dd>
    </dl>
  );
};

export default memo(CorporateCreateDefinitionList);
